export default "__VITE_ASSET__D_XYVGTx__"